var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('p',[_vm._v("SHARE PAGE:")]),_vm._v("\n  "+_vm._s(_vm.file)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }